export default "__VITE_ASSET__42ae6d60__"